// ClearOTPOnExit.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: "aes" });

const ClearOtpOnExit = () => {
  const location = useLocation();

  useEffect(() => {
    const isInBillRoute = location.pathname.startsWith("/reports/bill");
    if (!isInBillRoute) {
      ls.remove("otpValidatedForBills");
    }
  }, [location.pathname]); 

  return null;
};

export default ClearOtpOnExit;
